import { render } from "./Edit.vue?vue&type=template&id=192e6fdd"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Instructors/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "192e6fdd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('192e6fdd', __exports__)) {
    api.reload('192e6fdd', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=192e6fdd", () => {
    api.rerender('192e6fdd', render)
  })

}


export default __exports__